// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"34f4042a","268":"24a918f0","322":"cae094c6","567":"1c2167b4","853":"96382123"}[chunkId] + ".chunk.css";
};